'use client';

function handleItemKeyDown(event, {
  interactiveItemsLength,
  firstInteractiveIndex,
  previousItemIndex,
  nextItemIndex,
  setCurrentIndex,
  handleClose,
  currentIndex
}) {
  if (interactiveItemsLength > 0) {
    if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
      event.preventDefault();
      if (currentIndex === firstInteractiveIndex) {
        handleClose();
      }
      setCurrentIndex(previousItemIndex);
    }
    if (event.key === "ArrowDown" || event.key === "ArrowRight") {
      event.preventDefault();
      setCurrentIndex(nextItemIndex);
    }
    if (event.key === "Escape") {
      handleClose();
    }
    if (event.key === "Tab") {
      event.preventDefault();
      if (event.shiftKey) {
        if (currentIndex === firstInteractiveIndex) {
          handleClose();
        } else {
          setCurrentIndex(previousItemIndex);
        }
      } else {
        setCurrentIndex(nextItemIndex);
      }
    }
  }
}
export {
  handleItemKeyDown
};
